import React from 'react';

import { Header as BaseHeader, Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import ActionLink from 'components/action-button';
import { getDesignToken, primitive } from 'styles/constants';

export const Container = Box.withConfig({
  alignItems: 'center',
  flexDirection: 'column',
  width: '5/6',
  maxWidth: {
    md: getDesignToken('layout-smaller-section-max-width'),
  },
});

const Header = BaseHeader.withConfig({
  textAlign: 'center',
  color: primitive.$greyOne,
  fontFamily: 'heading',
  fontSize: '3xl',
  lineHeight: '2xs',
  marginBottom: '$0',
  textTransform: 'uppercase',
});

const Subheader = withTypography({ textAlign: 'center', mt: '$4', mx: '$0', mb: '$8' });

interface IEmptyStateProps {
  header: string;
  subheader: string;
  linkText: string;
  linkTo: string;
}

const EmptyState = ({ header, subheader, linkText, linkTo }: IEmptyStateProps) => {
  return (
    <Container>
      <Header>{header}</Header>
      <Subheader>{subheader}</Subheader>
      <ActionLink to={linkTo}>{linkText}</ActionLink>
    </Container>
  );
};

export default EmptyState;
